export default "assets/images/grapes-b02eba0f.svg";